
  <hsg-modal>
    <span class="title">כמה פרטים לזיהוי</span>
    <div [gaManager]="{type:'impression',category:this.gaCategory,action:'Login Started - fields presented',label:this.loginOriginAction}" class="body" ngForm #userDetailsLogin="ngForm" (ngSubmit)="submit(userDetailsLogin)" (keyup.enter)="userDetailsLogin.onSubmit()">
      <p>
        שדות בטופס המסומנים בכוכבית הינם שדות חובה
       <span class="asterix">*</span>
        </p>    
      <div class="h-gr h-gr--nowrap">
              <div class="c-column-logo">
                  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 128 128">
                    <path d="M90.6,77.5c-1.4,0-2.5,1.1-2.5,2.5v32.8c0,2-1.7,3.7-3.7,3.7H15.3c-2.1,0-3.8-1.7-3.8-3.8v-80h18.8
                      c0.7,0,1.3-0.3,1.8-0.7s0.7-1.1,0.7-1.8l0-18.8h51.6c2.1,0,3.8,1.7,3.8,3.8v7.9c0,1.4,1.1,2.5,2.5,2.5s2.5-1.1,2.5-2.5v-7.9
                      c0-4.8-3.9-8.7-8.7-8.7H30.3c-0.2,0-0.3,0-0.5,0c0,0,0,0,0,0c-0.2,0-0.4,0.1-0.6,0.2c0,0-0.1,0-0.1,0.1c-0.2,0.1-0.4,0.2-0.5,0.4
                      L7.2,28.5c-0.2,0.2-0.3,0.3-0.4,0.5c0,0-0.1,0.1-0.1,0.1c-0.1,0.2-0.2,0.4-0.2,0.6c0,0,0,0,0,0c0,0.2,0,0.3,0,0.5v82.4
                      c0,4.8,3.9,8.7,8.7,8.7h69.2c4.8,0,8.7-3.9,8.7-8.7V80C93.1,78.6,92,77.5,90.6,77.5z M15,27.8L27.8,15l0,12.8H15z"/>
                    <path d="M54.1,58.7c0-1.4-1.1-2.5-2.5-2.5H23.2c-1.4,0-2.5,1.1-2.5,2.5s1.1,2.5,2.5,2.5h28.4
                      C53,61.2,54.1,60,54.1,58.7z"/>
                    <path d="M68.3,48c0-1.4-1.1-2.5-2.5-2.5H23.2c-1.4,0-2.5,1.1-2.5,2.5s1.1,2.5,2.5,2.5h42.6
                      C67.1,50.5,68.3,49.4,68.3,48z"/>
                    <path d="M37.4,110.8h35.5c1.4,0,2.5-1.1,2.5-2.5s-1.1-2.5-2.5-2.5H37.4c-1.4,0-2.5,1.1-2.5,2.5S36,110.8,37.4,110.8z"/>
                    <path d="M121.5,30.7c0-5.5-4.5-10-10-10c-2.7,0-5.2,1-7.1,2.9l-51,51c0,0-0.1,0.1-0.1,0.1c-0.1,0.1-0.1,0.1-0.2,0.2
                      C53.1,75,53,75.1,53,75.2c0,0-0.1,0.1-0.1,0.1L42.3,96.6c-0.5,1-0.3,2.1,0.5,2.9c0.5,0.5,1.1,0.7,1.8,0.7c0.4,0,0.8-0.1,1.1-0.3
                      l21.3-10.6c0,0,0.1-0.1,0.1-0.1c0.1,0,0.1-0.1,0.2-0.1c0.1,0,0.1-0.1,0.2-0.2c0,0,0.1-0.1,0.1-0.1l49.7-49.7c0,0,0,0,0,0s0,0,0,0
                      l1.3-1.3C120.4,35.9,121.5,33.4,121.5,30.7z M116.5,30.7c0,1.1-0.4,2.2-1.1,3.1l-7.1-7.1c0.9-0.7,2-1.1,3.1-1.1
                      C114.3,25.7,116.5,27.9,116.5,30.7z M110.1,39.2l-7.1-7.1l1.8-1.8l7.1,7.1L110.1,39.2z M99.5,35.6l7.1,7.1L65.8,83.6l-7.1-7.1
                      L99.5,35.6z M54.4,90l-2.2-2.2l3.6-7.1l5.8,5.8L54.4,90z"/>
                  </svg>
                  
                  
              </div>

        <div class="h-cl">
          <p>
            נא הזן תעודת זהות ומספר טלפון נייד.
          </p>
          <div class="h-gr">
            <div class="h-cl">
              <hsg-field>
              <label for="uid">מספר תעודת זהות</label>
              <input type="tel" class="h-field__element" name="uid" id="uid" aria-invalid="false"
               hsgInput
               required
               maxlength="9"
               tzValidator
               ngModel
               #tz="ngModel">
               <label hsgLabel>מספר תעודת זהות</label>
               <div hsgError *ngIf="tz.invalid && userDetailsLogin.submitted">
                 <div hsgError *ngIf="tz?.errors?.required">
                     לא הוזן מספר תעודת זהות
                 </div>
                 <div hsgError *ngIf="tz?.errors?.tzValue">
                     מספר תעודת הזהות אינו תקין
                 </div>
               </div>
                </hsg-field>
              </div>
            <div class="h-cl">
              <hsg-field>
                <input type="tel" class="h-field__element" name="phone" id="phone" aria-invalid="false"
                required
                hsgInput
                pattern="^05[012345789]\d{7}$"
                maxlength="11"
                ngModel
                #phone="ngModel">
                <label hsgLabel>מספר טלפון נייד</label>
                <div hsgError *ngIf="phone.invalid && userDetailsLogin.submitted">
                    <div hsgError *ngIf="phone?.errors?.required">
                        לא הוזן מספר טלפון נייד        
                      </div>        
                    <div hsgError *ngIf="phone?.errors?.pattern && phone?.value?.indexOf('-') == -1">
                      מספר הטלפון לא תקין
                    </div>
                    <div hsgError *ngIf="phone?.value?.indexOf('-') != -1">
                      יש להזין מספר טלפון באורך 10 ספרות ללא מקף
                  </div>
                </div>
              </hsg-field>
            </div>
          </div>
          <div hsgError *ngIf="serverError">
              {{ serverError | json}}
            </div>
        </div>
      </div>
    </div>
    <div class="actions">
      <button hsg-button kind="primary" (click)="userDetailsLogin.onSubmit()" [disabled]="pending">התחבר
        <hsg-spinner *ngIf="pending" class="u-mr-s"></hsg-spinner>
      </button>
    </div>
  </hsg-modal>
  